/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HistoricoFonteDto } from '../models/historico-fonte-dto';
import { InventarioFontesSeladasCriteriaDto } from '../models/inventario-fontes-seladas-criteria-dto';
import { InventarioFontesSeladasDto } from '../models/inventario-fontes-seladas-dto';
import { InventarioFontesSeladasFormDto } from '../models/inventario-fontes-seladas-form-dto';
import { InventarioFontesSeladasPageDto } from '../models/inventario-fontes-seladas-page-dto';


/**
 * Inventário das Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class InventarioFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getInventariosFontesSeladas
   */
  static readonly GetInventariosFontesSeladasPath = '/inventario-fontes-seladas';

  /**
   * Pesquisar Inventário Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventariosFontesSeladas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventariosFontesSeladas$Response(params?: {
    criteria?: InventarioFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<InventarioFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, InventarioFontesSeladasService.GetInventariosFontesSeladasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InventarioFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Inventário Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInventariosFontesSeladas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventariosFontesSeladas(params?: {
    criteria?: InventarioFontesSeladasCriteriaDto;
  }): Observable<InventarioFontesSeladasPageDto> {

    return this.getInventariosFontesSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<InventarioFontesSeladasPageDto>) => r.body as InventarioFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation getInventarioFontesSeladas
   */
  static readonly GetInventarioFontesSeladasPath = '/inventario-fontes-seladas/{id}';

  /**
   * Obter detalhe inventário fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventarioFontesSeladas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventarioFontesSeladas$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<InventarioFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, InventarioFontesSeladasService.GetInventarioFontesSeladasPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InventarioFontesSeladasDto>;
      })
    );
  }

  /**
   * Obter detalhe inventário fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInventarioFontesSeladas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventarioFontesSeladas(params: {
    id: number;
  }): Observable<InventarioFontesSeladasDto> {

    return this.getInventarioFontesSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<InventarioFontesSeladasDto>) => r.body as InventarioFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateInventario
   */
  static readonly UpdateInventarioPath = '/inventario-fontes-seladas/{id}';

  /**
   * Atualizar inventario de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventario()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventario$Response(params: {
    id: number;
    body?: InventarioFontesSeladasFormDto
  }): Observable<StrictHttpResponse<InventarioFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, InventarioFontesSeladasService.UpdateInventarioPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InventarioFontesSeladasDto>;
      })
    );
  }

  /**
   * Atualizar inventario de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateInventario$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventario(params: {
    id: number;
    body?: InventarioFontesSeladasFormDto
  }): Observable<InventarioFontesSeladasDto> {

    return this.updateInventario$Response(params).pipe(
      map((r: StrictHttpResponse<InventarioFontesSeladasDto>) => r.body as InventarioFontesSeladasDto)
    );
  }

  /**
   * Path part for operation getExportInventario
   */
  static readonly GetExportInventarioPath = '/inventario-fontes-seladas/{codEstabelecimento}/exportar';

  /**
   * Documento do Inventário de um Titular.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportInventario()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportInventario$Response(params: {
    codEstabelecimento: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, InventarioFontesSeladasService.GetExportInventarioPath, 'get');
    if (params) {
      rb.path('codEstabelecimento', params.codEstabelecimento, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Documento do Inventário de um Titular.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportInventario$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportInventario(params: {
    codEstabelecimento: string;
  }): Observable<Blob> {

    return this.getExportInventario$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation docFrn
   */
  static readonly DocFrnPath = '/inventario-fontes-seladas/{id}/frn';

  /**
   * Documento Folha de Registo Normalizada.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `docFrn()` instead.
   *
   * This method doesn't expect any request body.
   */
  docFrn$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, InventarioFontesSeladasService.DocFrnPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Documento Folha de Registo Normalizada.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `docFrn$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  docFrn(params: {
    id: number;
  }): Observable<Blob> {

    return this.docFrn$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getHistoricoInventarioFonte
   */
  static readonly GetHistoricoInventarioFontePath = '/inventario-fontes-seladas/{id}/historico';

  /**
   * Obter historico de uma dada fonte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHistoricoInventarioFonte()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHistoricoInventarioFonte$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Array<HistoricoFonteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, InventarioFontesSeladasService.GetHistoricoInventarioFontePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HistoricoFonteDto>>;
      })
    );
  }

  /**
   * Obter historico de uma dada fonte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHistoricoInventarioFonte$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHistoricoInventarioFonte(params: {
    id: number;
  }): Observable<Array<HistoricoFonteDto>> {

    return this.getHistoricoInventarioFonte$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HistoricoFonteDto>>) => r.body as Array<HistoricoFonteDto>)
    );
  }

}
